<template>
  <div class="knowledge-show">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/01.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/02.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/03.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/04.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/05.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/06.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/07.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/08.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/09.png" alt="">
    <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/10.png" alt="">
    <!-- <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/11.png" alt=""> -->
    <!-- <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/new/12.png" alt=""> -->
    <div class="knowledge-show-bottom">
      <div class="knowledge-show-bottom-btn" @click="goto">
      
      </div>
      <img @click.prevent src="//cdn.iciba.com/www/edu_m/knowledge-show/08.png" alt="">      
    </div>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/knowledge-show'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { setTimeout } from 'timers';


export default {
  data () {
    return {
      hideBtn: false,
      timer: ''
    }
  },
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    goto() {
      setTimeout(() => {
        this.$router.push('/money')
      }, 300)
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    this.init()
    // 暂时处理iphone吸底问题
    this.timer = setTimeout(() => {
      this.hideBtn = true
    }, 300)
  },
  beforeDestroy () {
    window.clearTimeout(this.timer)
    this.$store.unregisterModule(module.name)
  },
  components: {
    
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.knowledge-show {
  font-size: 0;
  padding-bottom: rem(100);
  img {
    width: 100%;
  }
  &-bottom{
    position: fixed;
    bottom: 0;
    &-btn {
      position: absolute;
      animation: glow 500ms ease-out infinite alternate;
      width: rem(412);
      height: rem(72);
      bottom: 13%;
      left: 49%;
      border-radius: rem(30);
      transform: translateX(-50%);
    }
  }
}
@keyframes glow {
    0% {
        box-shadow: 0 0 5px rgba(0,0,0,.2), inset 0 0 5px rgba(0,0,0,.1), 0 1px 0 rgba(255,255,255,0);
    }
    100% {
        box-shadow: 0 0 20px rgba(0,0,0,.6), inset 0 0 10px rgba(0,0,0,.4), 0 1px 0 rgba(255,255,255,0);
    }
}
</style>
